import { useCallback, useMemo } from 'react';
import { Company, UserType } from 'api/models';
import { useAccountDataQuery } from 'queries/account';

interface Result {
  isDependentEntitiesLoading: boolean;
  isCurrentUserCustomer: () => boolean;
  updateCompanyIfNonStrategic: (company: Company) => Company;
  isNonStrategicCompany: (company: Company) => boolean;
}
export const useHideNonStrategicPartner = (): Result => {
  const { data, isLoading } = useAccountDataQuery();
  const vendorCompany = useMemo(
    () => data?.account.company,
    [data?.account.company],
  );
  const isCurrentUserCustomer = useCallback(
    () => data?.userProfile.user.userType === UserType.External,
    [data?.userProfile.user.userType],
  );
  const isNonStrategicCompany = useCallback(
    (company: Company) => company.strategic === false,
    [],
  );
  const updateCompanyIfNonStrategic = useCallback(
    (company: Company) =>
      vendorCompany != null && isNonStrategicCompany(company)
        ? vendorCompany
        : company,
    [isNonStrategicCompany, vendorCompany],
  );

  return {
    isDependentEntitiesLoading: isLoading,
    isCurrentUserCustomer,
    updateCompanyIfNonStrategic,
    isNonStrategicCompany,
  };
};
